import { render, staticRenderFns } from "./zhaoguDetail.vue?vue&type=template&id=4ac9bee0&scoped=true"
import script from "./zhaoguDetail.vue?vue&type=script&lang=js"
export * from "./zhaoguDetail.vue?vue&type=script&lang=js"
import style0 from "./zhaoguDetail.vue?vue&type=style&index=0&id=4ac9bee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac9bee0",
  null
  
)

export default component.exports